import { map, pick } from 'lodash'

const transformToSaveCourseTypesArgs = data =>
  map(data, (node, index) => ({
    ...pick(node, [
      'id',
      'name',
      'parentId',
      'isCurationEnabled',
      'isIgnored',
      'isDefaultFilter',
    ]),
    children: transformToSaveCourseTypesArgs(node.children),
    position: index,
  }))

export default transformToSaveCourseTypesArgs
